<script>
import { Carousel, Slide } from 'vue-carousel';

export default {
  render: function (createElement) {
    return createElement('carousel', {
      props: {
        perPageCustom: this.pageCustom,
        centerMode: false,
        navigationEnabled: true,
        paginationEnabled: false,
        rtl: document.body.dir == 'rtl' ? true : false
      },
      class: 'my-carousel' + (document.body.dir == 'rtl' ? ' rtlButtonForCarousel' : '')
    }, this.$slots.default.map((item) => {
        if (item.tag) {
          return createElement('slide', {
            scopedSlots: {
              default: props => item
            }
          });
        }
      })
    );
  },
  props: {
    pageCustom: Array
  },
  components: {
    Carousel,
    Slide
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .VueCarousel-slide {
    flex-grow: 1;
  }
  .VueCarousel-navigation {
    button {
      transform: none;
      top: 0;
      height: 64px;
      width: 25px;
      font-size: 10px;
      color: white;
      background: linear-gradient(180deg, $mainGreen 0%, $mainGreen 100%);
      margin: 0 !important;

      &.VueCarousel-navigation--disabled {
        background: #bebebe;
        opacity: 1;
      }
    }

    .VueCarousel-navigation-prev {
      left: 0;
      right: auto;
    }
    .VueCarousel-navigation-next {
      left: auto;
      right: 0;
    }
  }

}
.rtlButtonForCarousel ::v-deep{
  .VueCarousel-navigation {
    button {
      transform: scaleX(-1);
    }

    .VueCarousel-navigation-prev {
      left: auto;
      right: 0;
    }
    .VueCarousel-navigation-next {
      left: 0;
      right: auto;
    }
  }
}

.my-carousel {
  max-width: 100%;
}
</style>